import { api } from './client';

export interface Order {
  id: string;
  orderNo: string;
  tenantId: string;
  subscriptionId: string;
  type: 'NEW' | 'RENEW' | 'UPGRADE' | 'DOWNGRADE';
  amount: number; // 分
  status: 'PENDING' | 'CREATED' | 'PAYING' | 'PAID' | 'FAILED' | 'CLOSED' | 'REFUNDED';
  channel?: 'WECHAT_NATIVE' | 'WECHAT_JSAPI' | 'ALIPAY_QR';
  paidAt?: string | null;
  createdAt: string;
  updatedAt: string;
  subscription?: {
    id: string;
    system?: {
      id: string;
      name: string;
      key: string;
    };
    plan?: {
      id: string;
      name: string;
      key: string;
    };
  };
}

export interface PayParams {
  orderId: string;
  orderNo: string;
  amount: number;
  systemName: string;
  planName: string;
  channel: 'WECHAT_NATIVE' | 'WECHAT_JSAPI' | 'ALIPAY_QR';
  expiresInSeconds: number;
  payParams: {
    appId: string;
    mchId: string;
    timeStamp: string;
    nonceStr: string;
    package: string;
    signType: string;
    paySign: string;
  };
  codeUrl: string;
  notifyHint?: string;
}

export const orderApi = {
  // 创建订单
  createOrder: async (data: { systemId: string; planId: string }) => {
    const response = await api.post<Order>('/api/orders', data);
    return response.data;
  },

  // 获取支付参数
  getPayParams: async (orderId: string) => {
    const response = await api.get<PayParams>(`/api/orders/${orderId}/pay-params`);
    return response.data;
  },

  // 查询订单状态
  getOrderStatus: async (orderId: string) => {
    const response = await api.get<Order>(`/api/orders/${orderId}`);
    return response.data;
  },

  // 模拟支付（用于测试）
  mockPay: async (orderId: string, success: boolean = true) => {
    const response = await api.post<Order>(`/api/orders/${orderId}/mock-pay?success=${success}`);
    return response.data;
  },

  // 获取我的订单列表
  getMyOrders: async () => {
    const response = await api.get<Order[]>('/api/orders/my');
    return response.data;
  },
};
